export default __webpack_public_path__ + "static/img4-36ef3655b12c00a7ca9b9abee5661063.png";